const school = {
    state: {
        addSchoolDialog: {
            title: '新增校区信息',
            type: 'add'
        }
    },
    getters: {
        addSchoolDialog: state => state.addSchoolDialog,
    },
    mutations: {
        SET_SCHOOL_DIALOG_TITLE: (state, type) => {
            console.log("SET_SCHOOL_DIALOG_TITLE");
            if (type === 'add') {
                state.addSchoolDialog.title = '新增校区信息'
                state.addSchoolDialog.type = 'add'
            } else {
                state.addSchoolDialog.title = '编辑校区信息'
                state.addSchoolDialog.type = 'edit'
            }
        }
    },
    actions: {

    }
}

export default school